module.exports = __webpack_public_path__ + "img/gw.620cece5.svg";